<!--===================================
=            DATAITERATION            =
====================================-->
<template>
	<!-- RATINGS CARDS -->


	<div>
		<v-row>
			<base-header>
				<div slot="page-header">Table Iterators</div>
			</base-header>
		</v-row>
		<v-row>
			<v-col class="col-12 col-md-12 col-sm-12">
				<base-card>
					<div slot="card-header">#Slots</div>
					<div slot="card-subheader">The v-data-iterator allows you to customize exactly how to display your
						data. In this example we are using a grid with cards.

					</div>

					<div slot="card-body">
						<div fluid>
							<v-switch v-model="singleExpand" label="Expand Single Item"></v-switch>
							<v-data-iterator   :items="desserts" item-key="name" :items-per-page="4"
											 :single-expand="singleExpand" hide-default-footer>
								<template v-slot:default="{ items, isExpanded, expand }">
									<v-row>
										<v-col v-for="item in items" :key="item.name" cols="12" sm="6" md="4" lg="3">
											<v-card>
												<v-card-title>
													<h4>{{ item.name }}</h4>
												</v-card-title>
												<v-switch :input-value="isExpanded(item)"
														  :label="isExpanded(item) ? 'Expanded' : 'Closed'"
														  class="pl-4 mt-0" @change="(v) => expand(item, v)"></v-switch>
												<v-divider></v-divider>
												<v-list v-if="isExpanded(item)" dense>
													<v-list-item>
														<v-list-item-content>Calories:</v-list-item-content>
														<v-list-item-content class="align-end">
															{{ item.calories }}
														</v-list-item-content>
													</v-list-item>
													<v-list-item>
														<v-list-item-content>Fat:</v-list-item-content>
														<v-list-item-content class="align-end">
															{{ item.fat }}
														</v-list-item-content>
													</v-list-item>
													<v-list-item>
														<v-list-item-content>Carbs:</v-list-item-content>
														<v-list-item-content class="align-end">
															{{ item.carbs }}
														</v-list-item-content>
													</v-list-item>
													<v-list-item>
														<v-list-item-content>Protein:</v-list-item-content>
														<v-list-item-content class="align-end">
															{{ item.protein }}
														</v-list-item-content>
													</v-list-item>
													<v-list-item>
														<v-list-item-content>Sodium:</v-list-item-content>
														<v-list-item-content class="align-end">
															{{ item.sodium }}
														</v-list-item-content>
													</v-list-item>
													<v-list-item>
														<v-list-item-content>Calcium:</v-list-item-content>
														<v-list-item-content class="align-end">
															{{ item.calcium }}
														</v-list-item-content>
													</v-list-item>
													<v-list-item>
														<v-list-item-content>Iron:</v-list-item-content>
														<v-list-item-content class="align-end">
															{{ item.iron }}
														</v-list-item-content>
													</v-list-item>
												</v-list>
											</v-card>
										</v-col>
									</v-row>
								</template>
							</v-data-iterator>
						</div>
					</div>
				</base-card>
			</v-col>
		
			<v-col class="col-12 col-md-12 col-sm-12">
				<base-card>
					<div slot="card-header">

						#Filter
					</div>
					<div slot="card-subheader">The v-data-iterator has both a header and footer slot for adding extra
						content.</div>
					<div slot="card-body">
						<div fluid>
							<v-data-iterator  :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" :items="items" :items-per-page.sync="itemsPerPage" :page.sync="page"
											 :search="search" :sort-by="sortBy.toLowerCase()" :sort-desc="sortDesc"
											 hide-default-footer>
								<template v-slot:header>
									<v-toolbar dark color="blue darken-3" class="mb-1">
										<v-text-field v-model="search" clearable flat solo-inverted hide-details
													  prepend-inner-icon="mdi-magnify" label="Search"></v-text-field>
										<template v-if="$vuetify.breakpoint.mdAndUp">
											<v-spacer></v-spacer>
											<v-select v-model="sortBy" flat solo-inverted hide-details :items="keys"
													  prepend-inner-icon="mdi-magnify" label="Sort by"></v-select>
											<v-spacer></v-spacer>
											<v-btn-toggle v-model="sortDesc" mandatory>
												<v-btn large depressed color="blue" :value="false">
													<v-icon>mdi-arrow-up</v-icon>
												</v-btn>
												<v-btn large depressed color="blue" :value="true">
													<v-icon>mdi-arrow-down</v-icon>
												</v-btn>
											</v-btn-toggle>
										</template>
									</v-toolbar>
								</template>

								<template v-slot:default="props">
									<v-row>
										<v-col v-for="item in props.items" :key="item.name" cols="12" sm="6" md="4"
											   lg="3">
											<v-card>
												<v-card-title class="subheading font-weight-bold">
													{{ item.name }}
												</v-card-title>

												<v-divider></v-divider>

												<v-list dense>
													<v-list-item v-for="(key, index) in filteredKeys" :key="index">
														<v-list-item-content :class="{ 'blue--text': sortBy === key }">
															{{ key }}:
														</v-list-item-content>
														<v-list-item-content class="align-end"
																			 :class="{ 'blue--text': sortBy === key }">
															{{ item[key.toLowerCase()] }}
														</v-list-item-content>
													</v-list-item>
												</v-list>
											</v-card>
										</v-col>
									</v-row>
								</template>

								<template v-slot:footer>
									<v-row class="mt-2" align="center" justify="center">
										<span class="grey--text">Items per page</span>
										<v-menu offset-y>
											<template v-slot:activator="{ on, attrs }">
												<v-btn dark text color="primary" class="ml-2" v-bind="attrs" v-on="on">
													{{ itemsPerPage }}
													<v-icon>mdi-chevron-down</v-icon>
												</v-btn>
											</template>
											<v-list>
												<v-list-item v-for="(number, index) in itemsPerPageArray" :key="index"
															 @click="updateItemsPerPage(number)">
													<v-list-item-title>{{ number }}</v-list-item-title>
												</v-list-item>
											</v-list>
										</v-menu>

										<v-spacer></v-spacer>

										<span class="mr-4  grey--text">
											Page {{ page }} of {{ numberOfPages }}
										</span>
										<v-btn fab dark color="blue darken-3" class="mr-1" @click="formerPage">
											<v-icon>mdi-chevron-left</v-icon>
										</v-btn>
										<v-btn fab dark color="blue darken-3" class="ml-1" @click="nextPage">
											<v-icon>mdi-chevron-right</v-icon>
										</v-btn>
									</v-row>
								</template>
							</v-data-iterator>
						</div>
					</div>
				</base-card>

			</v-col>
		</v-row>

	</div>
</template>
<script>
	import BaseCard from "../../components/Base/BaseCard.vue";
	import BaseHeader from "../../components/Base/BaseHeader.vue";
	export default {
		components: {
			BaseCard,
			BaseHeader
		},
		data: () => ({
			singleExpand: false,
			itemsPerPage: 4,
			desserts: [{
					name: 'Frozen Yogurt',
					calories: 159,
					fat: 6.0,
					carbs: 24,
					protein: 4.0,
					sodium: 87,
					calcium: '14%',
					iron: '1%',
				},
				{
					name: 'Ice cream sandwich',
					calories: 237,
					fat: 9.0,
					carbs: 37,
					protein: 4.3,
					sodium: 129,
					calcium: '8%',
					iron: '1%',
				},
				{
					name: 'Eclair',
					calories: 262,
					fat: 16.0,
					carbs: 23,
					protein: 6.0,
					sodium: 337,
					calcium: '6%',
					iron: '7%',
				},
				{
					name: 'Cupcake',
					calories: 305,
					fat: 3.7,
					carbs: 67,
					protein: 4.3,
					sodium: 413,
					calcium: '3%',
					iron: '8%',
				},
			],
			itemsPerPageArray: [4, 8, 12],
			search: '',
			filter: {},
			sortDesc: false,
			page: 1,
			itemsPerPage: 4,
			sortBy: 'name',
			keys: [
				'Name',
				'Calories',
				'Fat',
				'Carbs',
				'Protein',
				'Sodium',
				'Calcium',
				'Iron',
			],
			items: [{
					name: 'Frozen Yogurt',
					calories: 159,
					fat: 6.0,
					carbs: 24,
					protein: 4.0,
					sodium: 87,
					calcium: '14%',
					iron: '1%',
				},
				{
					name: 'Ice cream sandwich',
					calories: 237,
					fat: 9.0,
					carbs: 37,
					protein: 4.3,
					sodium: 129,
					calcium: '8%',
					iron: '1%',
				},
				{
					name: 'Eclair',
					calories: 262,
					fat: 16.0,
					carbs: 23,
					protein: 6.0,
					sodium: 337,
					calcium: '6%',
					iron: '7%',
				},
				{
					name: 'Cupcake',
					calories: 305,
					fat: 3.7,
					carbs: 67,
					protein: 4.3,
					sodium: 413,
					calcium: '3%',
					iron: '8%',
				},
				{
					name: 'Gingerbread',
					calories: 356,
					fat: 16.0,
					carbs: 49,
					protein: 3.9,
					sodium: 327,
					calcium: '7%',
					iron: '16%',
				},
				{
					name: 'Jelly bean',
					calories: 375,
					fat: 0.0,
					carbs: 94,
					protein: 0.0,
					sodium: 50,
					calcium: '0%',
					iron: '0%',
				},
				{
					name: 'Lollipop',
					calories: 392,
					fat: 0.2,
					carbs: 98,
					protein: 0,
					sodium: 38,
					calcium: '0%',
					iron: '2%',
				},
				{
					name: 'Honeycomb',
					calories: 408,
					fat: 3.2,
					carbs: 87,
					protein: 6.5,
					sodium: 562,
					calcium: '0%',
					iron: '45%',
				},
				{
					name: 'Donut',
					calories: 452,
					fat: 25.0,
					carbs: 51,
					protein: 4.9,
					sodium: 326,
					calcium: '2%',
					iron: '22%',
				},
				{
					name: 'KitKat',
					calories: 518,
					fat: 26.0,
					carbs: 65,
					protein: 7,
					sodium: 54,
					calcium: '12%',
					iron: '6%',
				},
			],
		}),
		computed: {
			numberOfPages() {
				return Math.ceil(this.items.length / this.itemsPerPage)
			},
			filteredKeys() {
				return this.keys.filter(key => key !== 'Name')
			},
		},
		methods: {
			nextPage() {
				if (this.page + 1 <= this.numberOfPages) this.page += 1
			},
			formerPage() {
				if (this.page - 1 >= 1) this.page -= 1
			},
			updateItemsPerPage(number) {
				this.itemsPerPage = number
			},
		},

	};
</script>


<!--====  End of DATAITERATION  ====-->